import { EnderecoDto } from "@/dtos/EnderedoDto";
import { api } from "./Api";
import { ApiResult } from "./ApiResult";

class EnderecoService {
    async buscarPorCep(cep: string): Promise<ApiResult<EnderecoDto>> {
        let { data: result } = await api.get<ApiResult<EnderecoDto>>(`Endereco/BuscarPorCEP/${cep}`);

        return result;
    }
}

//eslint-disable-next-line
export default new EnderecoService();